import { useQuery } from '@tanstack/react-query'
import { fetchApiWithToken } from '~/api/utils'
import type { FiltersState } from '~/components/Filters/FilterBar/types'
import { buildCompanyContactsSearch } from '~/domains/companies/companySearch'
import type { CompanyContactLDResponse } from '~/domains/companies/types'

export const useCompanyContacts = (
  companyId: number,
  barFilters: FiltersState
) => {
  const search = buildCompanyContactsSearch(companyId, barFilters)

  const { data, isLoading, isError } = useQuery({
    queryKey: ['companies', companyId, 'prospection-contacts', search],
    queryFn: () =>
      fetchApiWithToken<CompanyContactLDResponse>({
        method: 'get',
        url: `/v1/companies/prospection/contacts?${search}`,
        useLDJson: true
      }),
    staleTime: 60_000
  })

  return {
    data: data?.['hydra:member'] ?? [],
    isLoading,
    isError
  }
}
